import {
    TOGGLE_SIDEBAR
} from './actionTypes'

export const toggleSidebarFetch = (isopen) => {
    return ({
        type: TOGGLE_SIDEBAR,
        payload: isopen
    })
}